import { rangeContainsMarker } from '@fullcalendar/core/internal';
import {
  getProductData,
  OrderParams,
  ProductsData
} from 'api/dashboard/_request';
import Badge from 'components/base/Badge';
import EcomTotalOrdersChart from 'components/charts/e-charts/EcomTotalOrdersChart';
import EcomTotalProductChart from 'components/charts/e-charts/EcomTotalProductChart';
import React, { useEffect, useState } from 'react';
import { Card, Form, Col } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { RootState } from 'redux-state/store';

type RangeType = 'today' | 'week' | 'month' | 'year';

const PRESET_RANGES: { label: string; value: RangeType }[] = [
  { label: 'Today', value: 'today' },
  { label: 'This Week', value: 'week' },
  { label: 'This Month', value: 'month' },
  { label: 'This Year', value: 'year' }
];

const EcomTotalProductCard = () => {
  const { user } = useSelector((state: RootState) => state.auth);
  const id = user?._id;
  const [range, setRange] = useState<RangeType>('year');
  const [productData, setProductData] = useState<ProductsData[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const params = { range, id };
      try {
        const data = await getProductData(params);
        setProductData(data || []);
      } catch (error) {
        console.error('Failed to fetch product data:', error);
      }
    };
    fetchData();
  }, [range]);

  return (
    <Card className="h-100">
      <Card.Body>
        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center">
          <div className="mb-3 mb-sm-0">
            <h5 className="mb-1">Products</h5>
            <h6 className="text-body-tertiary">Last {range}</h6>
            <h4>{productData.length ?? 0}</h4>
          </div>
          <Col xs={12} sm={6}>
            <Form.Group controlId="rangeSelect">
              <Form.Select
                size="sm"
                value={range}
                onChange={e => setRange(e.target.value as RangeType)}
              >
                {PRESET_RANGES.map(({ label, value }) => (
                  <option key={value} value={value}>
                    {label}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
        </div>
        <div className="px-0 px-sm-3 pt-4">
          <EcomTotalProductChart data={productData} timeRange={range} />
        </div>
      </Card.Body>
    </Card>
  );
};

export default EcomTotalProductCard;
